module.exports = __webpack_public_path__ + "static/img/jeonbuk-innovation.5b4b136.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/jeonbuk-innovation.jpg
// module id = 7jGo
// module chunks = 0